module.exports = __webpack_public_path__ + "img/wild-rag-deck-03.7113e262.jpeg";